<script lang="ts">
    import {artists, Rose, roses} from "../rose.ts";
    import GalleryImage from "../shared/GalleryImage.svelte";
    import queryString from "query-string";
    import InfiniteLoading from 'svelte-infinite-loading';
    import BackButton from "../shared/BackButton.svelte";
    import Autocomplete from "@smui-extra/autocomplete";
    import Textfield from '@smui/textfield';
    import Chip, {Set as ChipSet, Text as ChipText, TrailingAction} from '@smui/chips';
    import {artistsWithRose} from "../rose";
    import {Text} from "@smui/list";
    import {gtag, searchCaseAccentInsensitive, shuffleArrayCopy} from "../utils";
    import Fab, {Icon} from "@smui/fab";
    import {Svg} from "@smui/common/elements";
    import {beforeUpdate, onDestroy, onMount} from "svelte";

    gtag('set', 'page_path', '/galeria');
    gtag('event', 'page_view');

    export let allowDescriptionFilter: boolean = true;
    export let location;
    let queryParams;
    if (location) {
        queryParams = queryString.parse(location.search);
        if (Object.keys(queryParams).length != 0) {
            const newUrl = `${location.origin}${location.pathname}`
            window.history.pushState({path: newUrl}, '', newUrl);
        }
    }

    let selectedArtists: string[] = [];

    function addArtistFilterByNameIfExists(artistName: string) {
        const artist = $artists.find(art => art.name == artistName);
        if (artist) {
            selectedArtists.push(artist.name);
        }
    }

    if (queryParams?.artist) {
        if (Array.isArray(queryParams.artist)) {
            queryParams.artist.forEach(addArtistFilterByNameIfExists)
        } else {
            addArtistFilterByNameIfExists(queryParams.artist);
        }
    }

    let newArtist;
    let newArtistText = '';

    $: if (newArtist) {
        if (!selectedArtists.includes(newArtist.name)) {
            selectedArtists.push(newArtist.name);
            selectedArtists = selectedArtists;
            newArtist = null;
            newArtistText = '';
        }
    }

    let descriptionFilter = '';


    let page = 1;
    const rosesPerPage = 9;
    let shuffledRoses: Rose[];
    let filteredRoses: Rose[];
    let shownRoses: Rose[];
    $: shuffledRoses = shuffleArrayCopy($roses);
    $: {
        if (selectedArtists.length > 0 && descriptionFilter) {
            filteredRoses = shuffledRoses.filter(r => selectedArtists.includes(r.artist) && r.description.toLowerCase().includes(descriptionFilter.toLowerCase()));
        } else if (selectedArtists.length > 0) {
            filteredRoses = shuffledRoses.filter(r => selectedArtists.includes(r.artist));
        } else if (descriptionFilter) {
            filteredRoses = shuffledRoses.filter(r => r.description.toLowerCase().includes(descriptionFilter.toLowerCase()));
        } else {
            filteredRoses = shuffledRoses;
        }
    }

    function updateFilters() {
        selectedArtists = selectedArtists;
    }

    $: shownRoses = filteredRoses.slice(0, page * rosesPerPage);

    function loadMoreRoses({detail: {loaded, complete}}) {
        page++;
        if (page * rosesPerPage > filteredRoses.length) {
            complete();
        } else {
            setTimeout(() => loaded(), 500);
        }
    }

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }

</script>

<svelte:head>
    <title>Roses UPC - Galeria</title>
</svelte:head>
<BackButton fallbackPath="/"/>

<h1>
    Totes les Roses UPC
</h1>

<nav>
    <div id="nav-filter-div">
        <h2>Filtra la galeria per descripció:</h2>
        {#if allowDescriptionFilter}
            <Textfield label="Descripció" bind:value={descriptionFilter} variant="outlined"
                       style="width: 100%; margin-top: 10px;">
            </Textfield>
        {/if}
    </div>
</nav>
<div class="gallery">
    {#each shownRoses as rose(rose.id)}
        <div class="gallery-image" onload="{() => {console.log('Loaded images')}}">
            <GalleryImage rose="{rose}"/>
        </div>
    {/each}

    {#key selectedArtists.length + $roses.length}
        <InfiniteLoading on:infinite={loadMoreRoses}>
            <div slot="noMore"></div>
            <div slot="noResults"></div>
            <div slot="error"></div>
            <div slot="spinner"></div>
        </InfiniteLoading>
    {/key}
</div>

<Fab id="go-top-button" on:click={scrollToTop}>
    <Icon component={Svg} viewBox="2 2 20 20">
        <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path>
    </Icon>
</Fab>

<style>
    h1 {
        border-top: 3px solid var(--main-color);
        margin-top: 0;
        padding-top: 15px;
        color: var(--main-color);
        font-size: 2.5em;
        font-weight: 500;
    }

    h2 {
        font-weight: 400;
    }

    nav {
        margin-bottom: 15px;
    }

    #nav-filter-div > div {
        display: flex;
    }

    .gallery {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1em;
        margin: auto auto 15px;
    }

    @media (max-width: 1200px) {
        .gallery {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 500px) {
        .gallery {
            grid-template-columns: 1fr;
        }
    }

    @keyframes append-animate {
        from {
            transform: scale(0);
            opacity: 0;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }

    .gallery-image {
        animation: append-animate .3s linear;
    }

    :global(#go-top-button) {
        position: fixed;
        bottom: 5vh;
        right: 5vw;
    }
</style>